import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CategoriesHttpService } from '../../../services/categories.http';
import { NotificationsService } from 'angular2-notifications';
import { getCategoryOptionsUtil } from "../../../utils/getCategoryOptions.util";

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss'],
})
export class CreateCategoryComponent implements OnChanges {
  @Input() public categories: any[] = [];
  @Input() public prefill: any;

  @Output() update = new EventEmitter();

  public innerForm = this.formBuilder.group({
    category_id: [''],
    category_title: ['', Validators.required],
    category_parent_id: [null],
  });

  public categoryOptions: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private categoriesService: CategoriesHttpService,
    private notifications: NotificationsService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['categories']?.currentValue?.length) {
      this.categoryOptions = getCategoryOptionsUtil(
        this.categories
      );
      this.categoryOptions.unshift({
        itemName: 'N/A - Top level category',
        id: null,
        depth: 0,
      });
    }

    if (changes['prefill']?.currentValue) {
      this.innerForm.patchValue(changes['prefill'].currentValue);
    }
  }

  submit() {
    this.categoriesService
      .saveUpdateCategory(this.innerForm.value)
      .subscribe(() => {
        this.notifications.success(
          'Success!',
          `Category ${this.innerForm.value.category_title} was successfully created`
        );
        this.innerForm.reset();
        this.update.emit();
      });
  }
}
